import { openBlock, createElementBlock, normalizeClass, pushScopeId, popScopeId, createElementVNode } from "vue";
/* empty css                      */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-arrow-thin-icon",
  props: {
    type: {
      type: String,
      validator(value) {
        return ["right", "default", "down", "left", "up"].includes(value);
      },
      default: "default"
    },
    gradient: {
      type: String,
      validator(value) {
        return ["gradient", "no-gradient"].includes(value);
      },
      default: "gradient"
    }
  },
  computed: {
    arrowIconClass() {
      return {
        [`uikit-arrow-thin-icon-${this.type}`]: true,
        [`uikit-arrow-thin-icon-${this.gradient}`]: true
      };
    }
  }
};
const _withScopeId = (n) => (pushScopeId("data-v-2c1a7ec4"), n = n(), popScopeId(), n);
const _hoisted_1 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("path", {
  d: "M1 12.3486H33",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1));
const _hoisted_2 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("path", {
  d: "M22 1.34863L33 12.3486L22 23.3486",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1));
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "34",
    height: "25",
    viewBox: "0 0 34 25",
    fill: "transparent",
    stroke: "currentColor",
    class: normalizeClass($options.arrowIconClass)
  }, _hoisted_3, 2);
}
const ArrowThinIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-2c1a7ec4"]]);
export {
  ArrowThinIcon as default
};
//# sourceMappingURL=ArrowThinIcon.vue.es.js.map
